<template>
  <div>
    <div class="flex items-center justify-evenly">
      <length-input
        :model-value="LengthImperial"
        step=".1"
        :max="maxValueImperial"
        class="w-5/12 text-blue-600 text-lg"
        unit="feet"
        @update:model-value="setMetricValue($event)"
        @change:model-value="changeMetricValue($event)"
      />
      <p class="">OR</p>
      <length-input
        :model-value="value"
        :step="stepSize"
        :max="max"
        class="w-5/12 text-blue-600 text-lg"
        unit="meters"
        @update:model-value="round($event)"
        @change:model-value="update($event)"
      />
    </div>
    <div v-if="errors" class="form-error text-right">{{ errors }} (m)</div>
  </div>
</template>

<script>
import LengthInput from './LengthInput'
import throttle from 'lodash/throttle'

export default {
  components: {
    LengthInput,
  },
  props: {
    system: Number,
    value   : {
      type: Number,
      default: 0,
    },
    stepSize: Number,
    min     : {
      type: Number,
      default: null,
    },
    max     : {
      type: Number,
      default: null,
    },
    errors  : {
      type: String,
      default: '',
    },
  },
  emits: ['input'],
  computed: {
    LengthImperial () {
      return this.value ? this.MetricToFeet(this.value) : null
    },
    stepSizeImperial() {
      return this.MetricToFeet(this.stepSize)
    },
    maxValueImperial() {
      return this.MetricToFeet(this.max)
    },
  },
  methods: {
    round: throttle(function(value) {
      value = parseFloat(value)
      value = Math.round(value * 2 ) / 2
      this.update(value)
    }, 150),
    update(value) {
      this.$emit('input', parseFloat(value))
    },
    setMetricValue (value) {
      value = parseFloat(value)
      setTimeout(() => {
        let meters = this.FeetsToMeters(value)
        if (this.system == 1) {
          let floor = meters - Math.floor(meters)
          if (floor) {
            meters = meters - floor
          }
        }
        this.update(meters)
      }, 600)
    },
    changeMetricValue(value) {
      value = parseFloat(value)
      if (this.LengthImperial < value) {
        value = this.value ? this.value + this.stepSize : this.stepSize
        this.update(value)
        return
      }

      value = this.value ? this.value - this.stepSize : this.stepSize
      this.update(this.value - this.stepSize)
    },
  },
}
</script>
